export default function generateSkeletonKeys(count: number): string[] {
  return Array.from({ length: count }, () => crypto.randomUUID());
}
